import { type ReactNode, useState } from "react";
import { LegalLine } from "@/components/LegalLine";
import { CheckingSession } from "@/features/risk/CheckingSession";
import { TurningWorld } from "./TurningWorld";

/**
 * The whole window before Pax opens: signed out, and while a new session is checked. It stays
 * mounted from one to the other, and so does its globe, so signing in never redraws the screen:
 * the sign-in page gives way to a scan down the same globe, over the same footer, and the shell
 * appears once, when Pax opens. The footer names reCAPTCHA throughout, since the check that
 * follows sign-in runs it.
 */
export function EntryScreen({ checking, children }: { checking: boolean; children: ReactNode }) {
  const [checked, setChecked] = useState(false);
  return (
    <div className="relative isolate flex h-dvh flex-col overflow-y-auto bg-background *:shrink-0">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10 flex items-center justify-center"
      >
        <TurningWorld scanning={checking} complete={checked} />
      </div>
      {checking ? <CheckingSession setChecked={setChecked} /> : children}
      <LegalLine recaptcha className="absolute inset-x-0 bottom-0 px-6 pb-4" />
    </div>
  );
}
